import { useQueryClient } from "@tanstack/react-query";
import { leadApi } from "api/lead";
import { InputSize } from "shared/components";
import { AssigneeSelect as SharedAssigneeSelect } from "shared/components/Assignee";

interface AssigneeSelectProps {
  value?: number | null;
  rowId?: string;
  inputClassName?: string;
  labelClassName?: string;
  onChange?: (partner_user_id: number | null) => void;
  label?: string;
  size?: InputSize;
}

export const AssigneeSelect = ({
  value,
  rowId,
  inputClassName,
  labelClassName,
  onChange,
  label,
  size
}: AssigneeSelectProps) => {
  const queryClient = useQueryClient();

  const handleAssign = async (
    row_id: string,
    partner_user_id: number | null
  ) => {
    return leadApi.assignLead({
      lead_id: Number(row_id),
      assignee_ids: partner_user_id !== null ? [partner_user_id] : []
    });
  };

  const handleAssignSuccess = () => {
    queryClient.refetchQueries({ queryKey: ["LEAD_ACTIVITY_LOG"] });
    queryClient.refetchQueries({ queryKey: ["LEADS_TABLE"] });
    if (rowId) queryClient.refetchQueries({ queryKey: ["LEAD", rowId] });
  };

  return (
    <SharedAssigneeSelect
      value={value}
      rowId={rowId}
      labelClassName={labelClassName}
      inputClassName={inputClassName}
      onChange={onChange}
      onAssign={handleAssign}
      onAssignSuccess={handleAssignSuccess}
      label={label}
      size={size}
      successMessage="Lead assigned successfully"
      errorMessage="Failed to assign lead"
    />
  );
};
